import { QueryClient } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { useBuildRequest } from 'hooks/api/base'
import { useAuth } from 'hooks/user'
import { useLDClient } from 'launchdarkly-react-client-sdk'
import { ComponentProps } from 'react'

export function RouterWithContext({
  queryClient,
  ...routerProps
}: { router: any; queryClient: QueryClient } & ComponentProps<typeof RouterProvider>) {
  const auth = useAuth()
  const buildRequest = useBuildRequest()
  const ldClient = useLDClient()
  return <RouterProvider context={{ queryClient, auth, buildRequest, ldClient }} {...routerProps} />
}
